import React, { useContext, useEffect, useState } from 'react';
import { Button, Input, Loader, Modal, Table } from '@itds/elements/index.js';
import { CarrierContext } from '../../../contexts/CarrierContext';
import Notification from '@carrier/components/Notification';

import EditFormTagDrawer from './Edit';

import { Api } from '@carrier/utils/Api';

const List = () => {
  const [form_tags, setFormTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [tag, setFormTag] = useState(null);
  const { notification, setNotification } = useContext(CarrierContext);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    const params = {};

    setLoading(true);

    if (search.length) {
      params.name = search;
    }

    Api.loadFormTags(params).then(response => {
      setFormTags(response.data);
      setLoading(false);
    });
  }, [search]);

  const loadFormTags = action => {
    const params = {};

    setLoading(true);

    if (search.length) {
      params.name = search;
    }

    Api.loadFormTags(params)
      .then(response => {
        setFormTags(response.data);
        setLoading(false);
        if (action === 'save') {
          setNotification({
            message: 'Successfully Saved Form Tag',
            type: 'success'
          });
        } else if (action === 'delete') {
          setNotification({
            message: 'Successfully Deleted Form Tag',
            type: 'success'
          });
        }
      })
      .catch(() => {
        setTimeout(() => {
          if (action === 'save') {
            setNotification({
              message: 'Unable to save form tag at this time',
              type: 'error'
            });
          } else if (action === 'delete') {
            setNotification({
              message: 'Unable to delete form tag at this time',
              type: 'error'
            });
          }
        }, 2000);
      });
  };

  const handleSearch = e => {
    if (e.keyCode === 13) {
      setSearch(e.target.value);
    }
  };

  const handleSave = () => {
    setFormTag(null);
    loadFormTags('save');
  };

  const handleDelete = (obj, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);
    setModal(true);
    setDeleteInfo(obj);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteFormTag(deleteInfo.id)
      .then(() => {
        loadFormTags('delete');
        setModal(null);
        setDeleteInfo(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteInfo(null);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <Notification {...notification} />
      <EditFormTagDrawer
        onClose={setFormTag.bind(null, null)}
        onSave={handleSave}
        show={!!tag}
        tag={tag}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 40 }}>
        <Input
          onKeyDown={handleSearch}
          placeholder='Search for a form tag'
          style={{ width: 300 }}
        />

        <Button onClick={setFormTag.bind(null, { id: null, name: '' })}>Add Form Tag</Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            is_sortable: true,
            label: 'Name'
          },
          {
            id: 'form_count',
            is_sortable: true,
            label: '# of Forms',
            render: tag => tag.form_count || 0,
            styles: { textAlign: 'center' }
          },
          {
            id: 'actions',
            render: tag => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, tag)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={form_tags}
        defaultSortColumn={{ id: 'name' }}
        onRowClick={setFormTag}
      />

      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteInfo.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{deleteInfo.name}"?
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default List;
